__turbopack_context__.v({
  "borderBottom": "index-module__341r8G__borderBottom",
  "button": "index-module__341r8G__button",
  "component__layout": "index-module__341r8G__component__layout",
  "headline": "index-module__341r8G__headline",
  "hide-for-large": "index-module__341r8G__hide-for-large",
  "hide-for-large-only": "index-module__341r8G__hide-for-large-only",
  "hide-for-medium": "index-module__341r8G__hide-for-medium",
  "hide-for-medium-only": "index-module__341r8G__hide-for-medium-only",
  "hide-for-small-only": "index-module__341r8G__hide-for-small-only",
  "icon": "index-module__341r8G__icon",
  "isExpanded": "index-module__341r8G__isExpanded",
  "item": "index-module__341r8G__item",
  "show-for-large": "index-module__341r8G__show-for-large",
  "show-for-large-only": "index-module__341r8G__show-for-large-only",
  "show-for-medium": "index-module__341r8G__show-for-medium",
  "show-for-medium-only": "index-module__341r8G__show-for-medium-only",
  "show-for-small-only": "index-module__341r8G__show-for-small-only",
  "subhead": "index-module__341r8G__subhead",
  "u-color-black": "index-module__341r8G__u-color-black",
  "u-color-blue": "index-module__341r8G__u-color-blue",
  "u-color-midnight": "index-module__341r8G__u-color-midnight",
  "u-color-primary-dark": "index-module__341r8G__u-color-primary-dark",
  "u-color-red": "index-module__341r8G__u-color-red",
  "u-color-white": "index-module__341r8G__u-color-white",
  "u-theme-black": "index-module__341r8G__u-theme-black",
  "u-theme-blue": "index-module__341r8G__u-theme-blue",
  "u-theme-dark": "index-module__341r8G__u-theme-dark",
  "u-theme-light": "index-module__341r8G__u-theme-light",
  "u-theme-red": "index-module__341r8G__u-theme-red",
  "u-theme-white": "index-module__341r8G__u-theme-white",
});
